import React, { memo } from 'react'

interface IEmailProps {
  label?: string
  value?: string
  format?: string
  mask?: string
  id?: string
  dataTest?: string
  required?: boolean
  className?: string
  email: string
  title: string
  subject?: string
}

export const Email = memo<IEmailProps>(
  ({ className, dataTest = 'email-input', email, subject, title }) => (
    <>
      <a
        className={`${className} fs-mask`}
        href={`mailto:${email}${subject}`}
        target='_blank'
        rel='noopener noreferrer'
        date-test={dataTest}>
        {title}
      </a>
    </>
  )
)
